/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_Per_MonthInputs */

const cs_billing_plan_per_month = /** @type {(inputs: Billing_Plan_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` / měs.`)
};

const en_billing_plan_per_month = /** @type {(inputs: Billing_Plan_Per_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` / mo`)
};

/**
* | output |
* | --- |
* | "/ mo" |
*
* @param {Billing_Plan_Per_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_per_month = /** @type {((inputs?: Billing_Plan_Per_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Per_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_per_month(inputs)
	return cs_billing_plan_per_month(inputs)
});